<template>
    <div class="tx-dealersearch module-search-results">
        <div class="search-results__results" v-if="!resultsIsEmpty()">
            <SearchResult
                    v-for="(result, index) in results"
                    :result="result"
                    :key="result.uid"
                    :clicked="isClicked(index)"
                    @mouseenter="$emit('mouseenterResult', index)"
                    @mouseleave="$emit('mouseleaveResult')"/>
        </div>
        <div class="search-results__load-more module-load-more" v-if="!resultsIsEmpty()">
            <div class="load-more__button" v-if="currentPage < numberOfPages">
                <button class="btn -btn-small -btn-alpha" @click="loadMore">
                    <span>{{ $t('dealersearch.pagination.button') }}</span>
                </button>
            </div>
            <div class="load-more__progress" v-if="initialized">
                <div class="progress__info">
                    <span class="meta" v-html="$t('dealersearch.pagination.info', { current: results.length, total: numberOfTotalItems })"></span>
                </div>
                <div class="progress__bar"><span :style="{ width: (results.length / numberOfTotalItems * 100) + '%' }"></span></div>
            </div>
        </div>
        <div class="search-results__error" v-if="loaded && resultsIsEmpty ()">
            <span>{{ $t('dealersearch.filter.error') }}</span>
        </div>
    </div>
</template>

<script>
import SearchResult from '@/components/SearchResult'
import { mapActions, mapState } from 'vuex'

export default {
  name: 'SearchResults',
  inject: ['phone'],
  data () {
    return {
      showTel: false
    }
  },
  components: {
    SearchResult
  },
  props: {
    clickedPoiIndex: {
      type: Number,
      default: -1
    }
  },
  computed: {
    ...mapState({
      initialized: state => state.initialized,
      results: state => state.dealer.dealers,
      currentPage: state => state.dealer.currentPage,
      itemsPerPage: state => state.dealer.itemsPerPage,
      numberOfPages: state => state.dealer.numberOfPages,
      numberOfTotalItems: state => state.dealer.numberOfTotalDealers,
      loaded: state => state.dealer.loaded,
      searchedCountry: state => state.country
    })
  },
  methods: {
    ...mapActions([
      'loadMore'
    ]),
    resultsIsEmpty () {
      return !(this.results.length > 0)
    },
    isClicked (index) {
      if (this.clickedPoiIndex === index) {
        return true
      }
      return false
    },
    handleTelLink (event) {
      if (!this.phone) {
        event.preventDefault()
        this.showTel = !this.showTel
      }
    }
  }
}
</script>
